import * as React from 'react';
import { flexTooltipHost, svgIconStyles } from '../../../../styles/iconStyles';
import { TooltipHost } from '@fluentui/react';
import { LanguageContext } from '../../../../../../utilities/LocalizationModule';

export const ChannelShareIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    const languageStrings = React.useContext(LanguageContext);

    return <TooltipHost content={languageStrings.Shared} styles={flexTooltipHost}>
        <svg role="presentation" focusable="false" aria-hidden viewBox="0 0 20 20" width={16} height={16} fill="currentColor" style={{ ...props.style, ...svgIconStyles, marginTop: 1 }}>
            <path
                d="M3 5.5A2.5 2.5 0 0 1 5.5 3h5A2.5 2.5 0 0 1 13 5.5a.5.5 0 0 1-1 0c0-.83-.67-1.5-1.5-1.5h-5C4.67 4 4 4.67 4 5.5v5c0 .83.67 1.5 1.5 1.5h4.51a2.25 2.25 0 1 1 .12 1H5.5A2.5 2.5 0 0 1 3 10.5v-5Zm8 6.75a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0ZM7.5 14a.5.5 0 0 0-.5.5A2.5 2.5 0 0 0 9.5 17h5a2.5 2.5 0 0 0 2.5-2.5v-5A2.5 2.5 0 0 0 14.5 7H9.87A2.25 2.25 0 1 0 10 8h4.51c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5h-5A1.5 1.5 0 0 1 8 14.5a.5.5 0 0 0-.5-.5Zm.25-7.5a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z"
                fill="currentColor"
            />
        </svg>
    </TooltipHost>
}